/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ visit: NonNullable<unknown>, signup: NonNullable<unknown>, plan: NonNullable<unknown>, checkIn: NonNullable<unknown> }} Shareofferrewards2Inputs */

const en_shareofferrewards2 = /** @type {(inputs: Shareofferrewards2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.visit} per visit · +${i?.signup} per new sign-up · +${i?.plan} per plan · +${i?.checkIn} per check-in`)
};

const de_shareofferrewards2 = /** @type {(inputs: Shareofferrewards2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.visit} pro Besuch · +${i?.signup} pro neuer Anmeldung · +${i?.plan} pro Plan · +${i?.checkIn} pro Check-in`)
};

/**
* | output |
* | --- |
* | "+{visit} per visit · +{signup} per new sign-up · +{plan} per plan · +{checkIn} per check-in" |
*
* @param {Shareofferrewards2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const shareofferrewards2 = /** @type {((inputs: Shareofferrewards2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shareofferrewards2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shareofferrewards2(inputs)
	return de_shareofferrewards2(inputs)
});
export { shareofferrewards2 as "shareOfferRewards" }